var generateClickableUrl = function generateClickableUrl(url) {
  return url.startsWith('www') ? "//".concat(url) : url;
};

export default generateClickableUrl;